import Color from '@arcgis/core/Color'
import { SimpleLineSymbol, SimpleFillSymbol, SimpleMarkerSymbol, PictureMarkerSymbol } from '@arcgis/core/symbols'
import { Point, Polyline, Polygon } from '@arcgis/core/geometry'
import { distance } from '@arcgis/core/geometry/geometryEngine'
import SpatialReference from '@arcgis/core/geometry/SpatialReference'
import Graphic from '@arcgis/core/Graphic'

export default {
  data () {
    return {
      IDENTIFICATION_SQUARE: {
        type: 'simple-fill',
        color: [140, 140, 222, 0.5],
        outline: {
          color: [0, 0, 0, 0.5],
          width: 2,
        },
      },
    }
  },
  methods: {
    createGraphic ({ geometry, attributes, r, g, b, symbolParam, graphicType }) {
      const symbol = symbolParam || this.createSymbol(graphicType || geometry.type, { r, g, b })
      return new Graphic({ geometry: geometry, symbol: symbol, ...(attributes && { attributes: attributes }) })
    },
    createPointGraphic (longitude, latitude, { r, g, b }) {
      const color = new Color([r, g, b, 0.4])
      const colorOutline = new Color([r, g, b, 1])

      const sls = new SimpleLineSymbol({ style: 'solid', color: color, width: 4 })
      const symbol = new SimpleMarkerSymbol({ style: 'circle', size: 10, outline: sls, color: colorOutline })
      const point = new Point({ longitude: longitude, latitude: latitude })
      return new Graphic({ geometry: point, symbol: symbol })
    },
    createSymbol (geometryType, { r, g, b }, invisible = false) {
      let symbol = null

      let color = new Color([r, g, b, 0.4])
      let colorOutline = new Color([r, g, b, 1])
      if (invisible) {
        color = new Color([0, 0, 0, 0])
        colorOutline = new Color([0, 0, 0, 0])
      }

      if (geometryType === 'point' || geometryType === 'multipoint') {
        const sls = new SimpleLineSymbol({ style: 'solid', color: color, width: 4 })
        symbol = new SimpleMarkerSymbol({ style: 'circle', size: 10, outline: sls, color: colorOutline })
      } else if (geometryType === 'polygon') {
        const sls = new SimpleLineSymbol({ style: 'solid', color: colorOutline, width: this.$store.getters.getHighlightPolygonOutlineWidth })
        symbol = new SimpleFillSymbol({ style: this.$store.getters.getHighlightPolygonFillStyle || 'none', outline: sls, color: color })
      } else if (geometryType === 'polyline') {
        symbol = new SimpleLineSymbol({ style: 'solid', color: colorOutline, width: this.$store.getters.getHighlightLineWidth })
      }
      return symbol
    },
    createMarkerSymbol ({ color, size, style, outlineColor, outlineWidth }) {
      return new SimpleMarkerSymbol({
        color: new Color([color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a]),
        size: size,
        style: style,
        outline: new SimpleLineSymbol({
          color: new Color([outlineColor.rgba.r, outlineColor.rgba.g, outlineColor.rgba.b, outlineColor.rgba.a]),
          width: outlineWidth,
        }),
      })
    },
    createPictureMarkerSymbol ({ url, height, width, angle }) {
      return new PictureMarkerSymbol({
        url: url,
        height: height,
        width: width,
        angle: angle,
      })
    },
    createLineSymbol ({ color, style, width }) {
      return new SimpleLineSymbol({
        color: new Color([color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a]),
        style: style,
        width: width,
      })
    },
    createPolygonSymbol ({ fillColor, outlineColor, fillStyle, outlineStyle, outlineWidth }) {
      return new SimpleFillSymbol({
        style: fillStyle,
        color: new Color([fillColor.rgba.r, fillColor.rgba.g, fillColor.rgba.b, fillColor.rgba.a]),
        outline: new SimpleLineSymbol({
          color: new Color([outlineColor.rgba.r, outlineColor.rgba.g, outlineColor.rgba.b, outlineColor.rgba.a]),
          style: outlineStyle,
          width: outlineWidth,
        }),
      })
    },
    createPointGeometry (pointCoords, spatialReference) {
      return new Point({ x: pointCoords[0], y: pointCoords[1], spatialReference: spatialReference || SpatialReference.WebMercator })
    },
    createPolylineGeometry (paths, spatialReference) {
      return new Polyline({ paths: paths, spatialReference: spatialReference || SpatialReference.WebMercator })
    },
    createPolygonGeometry (rings, spatialReference) {
      return new Polygon({ rings: rings, spatialReference: spatialReference || SpatialReference.WebMercator })
    },
    // used for feature selection on the map, isn't geodesic
    createBufferAroundPoint (view, clickEvent, pixelDistance) {
      try {
        const mapPoint1 = view.toMap({ x: clickEvent.x, y: clickEvent.y })
        const mapPoint2 = view.toMap({ x: clickEvent.x + pixelDistance, y: clickEvent.y })
        const centerToSideDistance = distance(mapPoint1, mapPoint2, 'meters')
        const xMax = mapPoint1.x + centerToSideDistance
        const xMin = mapPoint1.x - centerToSideDistance
        const yMax = mapPoint1.y + centerToSideDistance
        const yMin = mapPoint1.y - centerToSideDistance

        return new Polygon({
          rings: [
            [xMin, yMin], [xMax, yMin], [xMax, yMax], [xMin, yMax],
          ],
          spatialReference: SpatialReference.WebMercator,
        })
      } catch (error) {
        return null
      }
    },

  },
}
